<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'photoreasons') {
            next({ name: 'motivo-foto-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'photoreasons') {
            this.$router.push({ name: 'motivo-foto-list' });
        }
    },
};
</script>
